import React, { useEffect } from "react";
import "./Sections.css";
import { MdErrorOutline, MdAddCircleOutline } from "react-icons/md";
import CustomDropdown from "../Components/CustomDropdown/CustomDropdown";
import { FaRegTrashAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";
const DimensionsSection = ({
  formData,
  setFormData,
  errors,
  packageDetails,
  setPackageDetails,
}) => {
  const { t } = useTranslation("inventory");
  const handleFieldChange = (name, e) => {
    setFormData({
      ...formData,
      [name]: e.target.value,
    });
  };
  const handlePackageDimension = (name, value, index) => {
    setPackageDetails(
      packageDetails?.map((dim, idx) => {
        if (index === idx) {
          return { ...dim, [name]: value };
        } else {
          return dim;
        }
      })
    );
  };
  useEffect(() => {
    setFormData({
      ...formData,
      package_details: packageDetails,
    });
  }, [packageDetails]);
  return (
    <section className="addprod__formsection_wrap" id="addproduct_dimensions">
      <div className="addprod__formsection_heading">{t("productForm.productDimensions")}</div>
      <div className="addprod__custominput_flexrow">
        <div
          className="addprod__custominput_flexcol"
          style={{ minWidth: "100px" }}
        >
          <div className="addprod__custominput_box">
            <label className="addprod__custominput_title">
              {t("productForm.dimensionsUnit")}
            </label>
            <CustomDropdown
              optionObjects={[
                { title: t("productForm.inchIn"), value: "in" },
                { title: t("productForm.centemeterCm"), value: "cm" },
              ]}
              onSelect={(option) => {
                setFormData({ ...formData, dimension_unit: option });
              }}
              selectedOption={formData?.dimension_unit}
            />
            {Object.keys(errors)?.includes("dimension_unit") && (
              <div className="addprod__custominputfield_error">
                <MdErrorOutline className="addprod__custominputfield_erroricn" />
                {errors?.dimension_unit?.msg}
              </div>
            )}
          </div>
        </div>
        <div
          className="addprod__custominput_flexcol"
          style={{ minWidth: "100px" }}
        >
          <div className="addprod__custominput_box">
            <label className="addprod__custominput_title">{t("productForm.weightUnit")}</label>
            <CustomDropdown
              optionObjects={[
                { title: t("productForm.kilogramKg"), value: "kg" },
                { title: t("productForm.poundLb"), value: "lb" },
              ]}
              onSelect={(option) => {
                setFormData({ ...formData, weight_unit: option });
              }}
              selectedOption={formData?.weight_unit}
            />
            {Object.keys(errors)?.includes("weight_unit") && (
              <div className="addprod__custominputfield_error">
                <MdErrorOutline className="addprod__custominputfield_erroricn" />
                {errors?.weight_unit?.msg}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="addprod__custominput_flexrow">
        <div
          className="addprod__custominput_flexcol"
          style={{ minWidth: "100px" }}
        >
          <div className="addprod__custominput_box">
            <label className="addprod__custominput_title">{t("productForm.length")}</label>
            <input
              className="addprod__custominputfield"
              type="number"
              placeholder={t("productForm.enterLength")}
              onChange={(e) => handleFieldChange("length", e)}
              value={formData?.length}
            />
            {Object.keys(errors)?.includes("length") && (
              <div className="addprod__custominputfield_error">
                <MdErrorOutline className="addprod__custominputfield_erroricn" />
                {errors?.length?.msg}
              </div>
            )}
          </div>
        </div>
        <div
          className="addprod__custominput_flexcol"
          style={{ minWidth: "100px" }}
        >
          <div className="addprod__custominput_box">
            <label className="addprod__custominput_title">{t("productForm.width")}</label>
            <input
              className="addprod__custominputfield"
              type="number"
              placeholder={t("productForm.enterWidth")}
              onChange={(e) => handleFieldChange("width", e)}
              value={formData?.width}
            />
            {Object.keys(errors)?.includes("width") && (
              <div className="addprod__custominputfield_error">
                <MdErrorOutline className="addprod__custominputfield_erroricn" />
                {errors?.width?.msg}
              </div>
            )}
          </div>
        </div>
        <div
          className="addprod__custominput_flexcol"
          style={{ minWidth: "100px" }}
        >
          <div className="addprod__custominput_box">
            <label className="addprod__custominput_title">{t("productForm.height")}</label>
            <input
              className="addprod__custominputfield"
              type="number"
              placeholder={t("productForm.enterHeight")}
              onChange={(e) => handleFieldChange("height", e)}
              value={formData?.height}
            />
            {Object.keys(errors)?.includes("height") && (
              <div className="addprod__custominputfield_error">
                <MdErrorOutline className="addprod__custominputfield_erroricn" />
                {errors?.height?.msg}
              </div>
            )}
          </div>
        </div>
        <div
          className="addprod__custominput_flexcol"
          style={{ minWidth: "100px" }}
        >
          <div className="addprod__custominput_box">
            <label className="addprod__custominput_title">{t("productForm.weight")}</label>
            <input
              className="addprod__custominputfield"
              type="number"
              placeholder={t("productForm.enterWeight")}
              onChange={(e) => handleFieldChange("weight", e)}
              value={formData?.weight}
            />
            {Object.keys(errors)?.includes("weight") && (
              <div className="addprod__custominputfield_error">
                <MdErrorOutline className="addprod__custominputfield_erroricn" />
                {errors?.weight?.msg}
              </div>
            )}
          </div>
        </div>
      </div>{" "}
      <br />
      <div className="addprod__custominput_flexrow">
        <label className="addprod__formsection_heading">
          {t("productForm.packagesDimensions")}
        </label>
      </div>
      {packageDetails?.map((dimension, index) => (
        <div key={index} className="addprod__custominput_flexrow">
          <div
            className="addprod__custominput_flexcol"
            style={{ minWidth: "100px" }}
          >
            <div className="addprod__custominput_box">
              <label className="addprod__custominput_title">{t("productForm.length")}</label>
              <input
                className="addprod__custominputfield"
                type="number"
                placeholder={t("productForm.enterLength")}
                onChange={(e) =>
                  handlePackageDimension("length", e.target.value, index)
                }
                value={dimension?.length}
              />
              {Object.keys(errors)?.includes("length") && (
                <div className="addprod__custominputfield_error">
                  <MdErrorOutline className="addprod__custominputfield_erroricn" />
                  {errors?.length?.msg}
                </div>
              )}
            </div>
          </div>
          <div
            className="addprod__custominput_flexcol"
            style={{ minWidth: "100px" }}
          >
            <div className="addprod__custominput_box">
              <label className="addprod__custominput_title">{t("productForm.width")}</label>
              <input
                className="addprod__custominputfield"
                type="number"
                placeholder={t("productForm.enterWidth")}
                onChange={(e) =>
                  handlePackageDimension("width", e.target.value, index)
                }
                value={dimension?.width}
              />
              {Object.keys(errors)?.includes("width") && (
                <div className="addprod__custominputfield_error">
                  <MdErrorOutline className="addprod__custominputfield_erroricn" />
                  {errors?.width?.msg}
                </div>
              )}
            </div>
          </div>
          <div
            className="addprod__custominput_flexcol"
            style={{ minWidth: "100px" }}
          >
            <div className="addprod__custominput_box">
              <label className="addprod__custominput_title">{t("productForm.height")}</label>
              <input
                className="addprod__custominputfield"
                type="number"
                placeholder={t("productForm.enterHeight")}
                onChange={(e) =>
                  handlePackageDimension("height", e.target.value, index)
                }
                value={dimension?.height}
              />
              {Object.keys(errors)?.includes("height") && (
                <div className="addprod__custominputfield_error">
                  <MdErrorOutline className="addprod__custominputfield_erroricn" />
                  {errors?.height?.msg}
                </div>
              )}
            </div>
          </div>
          <div
            className="addprod__custominput_flexcol"
            style={{ minWidth: "100px" }}
          >
            <div className="addprod__custominput_box">
              <label className="addprod__custominput_title">{t("productForm.weight")}</label>
              <input
                className="addprod__custominputfield"
                type="number"
                placeholder={t("productForm.enterWeight")}
                onChange={(e) =>
                  handlePackageDimension("weight", e.target.value, index)
                }
                value={dimension?.weight}
              />
              {Object.keys(errors)?.includes("weight") && (
                <div className="addprod__custominputfield_error">
                  <MdErrorOutline className="addprod__custominputfield_erroricn" />
                  {errors?.weight?.msg}
                </div>
              )}
            </div>
          </div>
          <div
            className="addprod__custominput_flexcol"
            style={{ minWidth: "250px" }}
          >
            <div className="addprod__custominput_box">
              <label className="addprod__custominput_title">{t("productForm.description")}</label>
              <input
                className="addprod__custominputfield"
                type="text"
                placeholder={t("productForm.writeDescription")}
                onChange={(e) =>
                  handlePackageDimension("description", e.target.value, index)
                }
                value={dimension?.description}
              />
            </div>
          </div>
          <FaRegTrashAlt
            size={13}
            className="addprod__idensec_delrowicn"
            onClick={(e) =>
              setPackageDetails(
                packageDetails?.filter((item, idx) => idx !== index)
              )
            }
          />
        </div>
      ))}
      <div className="addprod__custominput_flexrow">
        <button
          className="addprod__formsection_addvarbtn"
          onClick={() =>
            setPackageDetails([
              ...packageDetails,
              {
                length: "",
                width: "",
                height: "",
                weight: "",
                description: "",
              },
            ])
          }
        >
          <MdAddCircleOutline
            className="addprod__formsection_addvarbtnicn"
            size={14}
          />
          {t("productForm.addDimension")}
        </button>
      </div>
    </section>
  );
};

export default DimensionsSection;
